<meta content="width=device-width, initial-scale=1" name="viewport"/>
<section class="main-slider" id="home">
    <div class="bg-slider banner slider-rtl-2">
        <div class="h-100 w-100 container">
          <div class="row h-100">
            <div class="col-lg-7 col-md-6 d-flex align-items-center justify-content-center">
              <div class="px-4">
               
                <ng-container *ngIf="activeId === 'slide-0'">
                    <h1 class="mb-3 banner-title" >
                        {{'home.slide1.title1' | translate}}
                        <br>
                        {{'home.slide1.title2' | translate}}
                    </h1>
                    <p class="banner-desc">
                        {{'home.slide1.desc' | translate}}
                    </p>
       
                </ng-container>
              </div>
            </div>
            <div class="col-lg-5 col-md-6 mt-4 pt-2 mt-sm-0 pt-sm-0 d-md-flex d-none px-0 align-items-center" *ngIf="activeId === 'slide-0'">
              <div class="classic-app-image position-relative">
                <div class="position-relative">
                  <img src="assets/images/laptop.png" class="img-fluid mover mx-auto d-block my-5" alt="">
                </div>
              </div>
            </div>

          </div>
        </div>
    </div>
</section>
